import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class F1120lSchAService {

  constructor(private http: HttpClient) { }

  /**
   * Fetch Schedule A Form View data
   * @param baseUrl Base URL from GENERAL_CONFIG
   * @param params Request parameters including action_id, screen_key, tax_year, form_no, schd_name, scenario, jcd_key, combination_key
   * @returns Observable with form view data
   */
  fetchSchdFormView(baseUrl: string, params: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    
    // Convert params to URLSearchParams for form-urlencoded format
    const formData = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        formData.set(key, params[key].toString());
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: true
    };

    return this.http.post<any>(url, formData.toString(), httpOptions);
  }

  /**
   * Get accounts data with drill-down functionality
   * @param baseUrl Base URL from GENERAL_CONFIG
   * @param params Request parameters including action_id, tax_year, screen_key, acct_key, combination_key, is_parent, line_no
   * @returns Observable with accounts data
   */
  getAccts(baseUrl: string, params: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    
    // Convert params to URLSearchParams for form-urlencoded format
    const formData = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        formData.set(key, params[key].toString());
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: true
    };

    return this.http.post<any>(url, formData.toString(), httpOptions);
  }
}

